export default __webpack_public_path__ + "static/media/img_about01-m.adb40880.png";